import { type ReactNode, useSyncExternalStore } from "react";
import {
  getMainContentTargetId,
  MAIN_CONTENT_ID,
  subscribeMainContentTarget,
} from "@/shared/lib/initialThreadHtml";

type SkipLinkProps = {
  className: string;
};

export function SkipToMainContentLink({
  className,
}: SkipLinkProps): React.ReactElement {
  const targetId = useSyncExternalStore(
    subscribeMainContentTarget,
    getMainContentTargetId,
    getServerMainContentTargetId,
  );

  return (
    <a href={`#${targetId}`} className={className}>
      本文へスキップ
    </a>
  );
}

type MainContentProps = {
  children: ReactNode;
  className: string;
};

export function MainContent({
  children,
  className,
}: MainContentProps): React.ReactElement {
  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1} className={className}>
      {children}
    </main>
  );
}

function getServerMainContentTargetId(): string {
  return MAIN_CONTENT_ID;
}
